import Vue from 'vue'

import OMButton from './OMButton'
import OMInput from './OMInput'
import OMTablePagination from './OMTablePagination'
import OMSelect from './OMSelect'
import OMAccordion from './OMAccordion'
import OMAutoComplete from './OMAutoComplete'
import OMDatepicker from './OMDatepicker'

Vue.component('OMButton', OMButton)
Vue.component('OMInput', OMInput)
Vue.component('OMTablePagination', OMTablePagination)
Vue.component('OMSelect', OMSelect)
Vue.component('OMAccordion', OMAccordion)
Vue.component('OMAutoComplete', OMAutoComplete)
Vue.component('OMDatepicker', OMDatepicker)
